import { DevaKathaLS1 } from "./DevaKathaLS1";
import { DevaKathaLS2 } from "./DevaKathaLS2";
import { DevaKathaLS3 } from "./DevaKathaLS3";
import { DevaKathaLS4 } from "./DevaKathaLS4";
import { DevaKathaLS5 } from "./DevaKathaLS5";
import { DevaKathaLS6 } from "./DevaKathaLS6";
import { DevaKathaLS7 } from "./DevaKathaLS7";
import { DevaKathaLS8 } from "./DevaKathaLS8";
import { DevaKathaLS9 } from "./DevaKathaLS9";
import { DevaKathaLS10 } from "./DevaKathaLS10";

const LS_MAP: Record<string, React.FC> = {
  ls_01: DevaKathaLS1,
  ls_02: DevaKathaLS2,
  ls_03: DevaKathaLS3,
  ls_04: DevaKathaLS4,
  ls_05: DevaKathaLS5,
  ls_06: DevaKathaLS6,
  ls_07: DevaKathaLS7,
  ls_08: DevaKathaLS8,
  ls_09: DevaKathaLS9,
  ls_10: DevaKathaLS10,
};

export const LikeSubscribeRouter: React.FC<{ variant: string }> = ({ variant }) => {
  const Component = LS_MAP[variant];
  if (!Component) return null;
  return <Component />;
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
